<h1>{{ 'teams.player_signup.title' | translate }}</h1>

<form class="form" [formGroup]="registerForm" (ngSubmit)="submit()">

  <app-form-input
    id="email"
    type="email"
    [label]="'teams.player_signup.email' | translate"
    [required]="true"
    formControlName="email"
    [control]="getControl('email')"
  />

  <app-form-input
    id="account_activision"
    [label]="'teams.player_signup.activision_id' | translate"
    [required]="true"
    formControlName="account_activision"
    [control]="getControl('account_activision')"
  />

  <app-form-input
    id="username"
    [label]="'teams.player_signup.username' | translate"
    autocomplete="off"
    [required]="true"
    formControlName="username"
    [control]="getControl('username')"
  />

  <app-form-input
    id="password"
    [label]="'teams.player_signup.password' | translate"
    type="password"
    autocomplete="off"
    [required]="true"
    formControlName="password"
    [control]="getControl('password')"
  />

    <div class="form-navbar mt-40">
        <button class="app-button basic" type="button" (click)="close()">{{ 'common.back' | translate }}</button>
        <button class="app-button" type="submit" [disabled]="registerForm.invalid">{{ 'common.send' | translate }}</button>
    </div>
</form>

<div class="mt-50"></div>

<app-contact [hideTitle]="true"></app-contact>
